module.exports = __webpack_public_path__ + "static/media/pngkit_call.bd8d09b7.png";